import { render, staticRenderFns } from "./LfTotalsComponent.vue?vue&type=template&id=d64b7504"
import script from "./LfTotalsComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./LfTotalsComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LfTotalsComponent.vue?vue&type=style&index=0&id=d64b7504&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d64b7504')) {
      api.createRecord('d64b7504', component.options)
    } else {
      api.reload('d64b7504', component.options)
    }
    module.hot.accept("./LfTotalsComponent.vue?vue&type=template&id=d64b7504", function () {
      api.rerender('d64b7504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LfTotals/LfTotalsComponent.vue"
export default component.exports